// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1B2dF","tab":"Tabs_tab__3P6hQ","tabActive":"Tabs_tabActive__3IDLY"};